<template>
    <div class="addProp-box">
        <h3 class="subtitle">{{$t('addProperty.Location')}}: {{collection.country.name}}</h3>
        <el-form
            :label-position="'top'"
            label-width="80px"
            ref="formProp2"
            :rules="formRule2"
            :model="formProp2"
            v-if="property_country_flag == ''"
        >
            <el-row :gutter="8" class="type-card">
                <el-col :sm="12" :xs="24">
                    <el-form-item prop="city" :label="$t('addProperty.city')">
                        <el-input
                            :placeholder="$t('addProperty.placeholder_City')"
                            v-model="formProp2.city"
                            clearable
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :sm="12" :xs="24">
                    <el-form-item prop="postalCode" :label="$t('addProperty.postalCode')">
                        <el-input placeholder="200040" v-model="formProp2.postalCode" clearable></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-form-item prop="address" :label="$t('addProperty.address1')">
                <el-input
                    :placeholder="$t('addProperty.placeholder_address1')"
                    v-model="formProp2.address"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item prop="addressLine2" :label="$t('addProperty.address2')">
                <el-input
                    :placeholder="$t('addProperty.placeholder_address2')"
                    v-model="formProp2.addressLine2"
                    clearable
                ></el-input>
            </el-form-item>

            <el-form-item
                :label="$t('addProperty.propertyName')"
                prop="name"
                class="border-bottom"
                v-if="collection.propertyType != '3'"
            >
                <el-input
                    :placeholder="$t('addProperty.placeholder_propertyName')"
                    v-model="formProp2.name"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item
                :label="$t('addProperty.propertyName')"
                prop="name"
                v-if="collection.propertyType == '3'"
            >
                <el-input
                    :placeholder="$t('addProperty.placeholder_propertyName')"
                    v-model="formProp2.name"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item
                :label="$t('addProperty.unitNo')"
                class="border-bottom"
                prop="apartmentNumber"
                v-if="collection.propertyType == '3'"
            >
                <el-input v-model="formProp2.apartmentNumber" clearable></el-input>
            </el-form-item>

            <el-form-item
                :label="$t('addProperty.purchasePrice')"
                class="p-relative"
                prop="purchasePrice"
            >
                <span class="prepend placeholderPend">{{collection.country.currency_symbol}}</span>
                <numeric-input type="number" v-model="formProp2.purchasePrice"></numeric-input>
                <span class="append placeholderPend">{{collection.country.currency}}</span>
            </el-form-item>
            <el-form-item
                :label="$t('addProperty.ownership')"
                class="strongText"
                prop="ownershipType"
            >
                <el-row>
                    <el-radio-group v-model="formProp2.ownershipType">
                        <el-col :span="24">
                            <el-radio
                                class="normal"
                                label="Freehold"
                            >{{$t('addProperty.ownership_Freehold')}}</el-radio>
                        </el-col>
                        <el-col :span="24">
                            <el-radio
                                class="normal"
                                label="Leasehold"
                            >{{$t('addProperty.ownership_Leasehold')}}</el-radio>
                        </el-col>
                    </el-radio-group>
                </el-row>
            </el-form-item>

            <el-form-item
                :label="$t('addProperty.totalLength')"
                prop="leaseholdDuration"
                v-if="formProp2.ownershipType == 'Leasehold'"
            >
                <el-input-number
                    v-model="formProp2.leaseholdDuration"
                    :min="1"
                    :max="100"
                    :label="$t('addProperty.years', {years: formProp2.leaseholdDuration})"
                ></el-input-number>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="goToStep">{{$t('addProperty.next')}}</el-button>
            </el-form-item>
        </el-form>

        <el-form
            :label-position="'top'"
            label-width="80px"
            ref="formPropHK"
            :rules="formRuleHK"
            :model="formPropHK"
            v-if="property_country_flag == 'HK'"
        >
            <el-form-item :label="$t('addProperty.propertyName')" prop="name">
                <el-select
                    v-model="formPropHK.name"
                    @change="changeHKPropertyName"
                    :loading="loading"
                    filterable
                    allow-create
                    default-first-option
                    value-key="id"
                    :placeholder="$t('addProperty.placeholder_propertyName')"
                    v-if="lan == 'en'"
                >
                    <el-option
                        v-for="item in locationList"
                        :key="item.id"
                        :label="item.ename"
                        :value="item"
                    ></el-option>
                </el-select>

                <el-select
                    v-model="formPropHK.name"
                    @change="changeHKPropertyName"
                    :loading="loading"
                    filterable
                    allow-create
                    default-first-option
                    :placeholder="$t('addProperty.placeholder_propertyName')"
                    value-key="id"
                    v-if="lan != 'en'"
                >
                    <el-option
                        v-for="item in locationList"
                        :key="item.id"
                        :label="item.name"
                        :value="item"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('addProperty.building')" prop="building_name">
                <el-select
                    v-model="formPropHK.building_name"
                    :loading="loading"
                    filterable
                    allow-create
                    :placeholder="$t('addProperty.placeholder_BuildingA')"
                    @change="changeHKPropertyBuilding"
                    v-if="lan == 'en'"
                >
                    <el-option
                        v-for="item in buidlingList"
                        :key="item.id"
                        :label="item.ename"
                        :value="item"
                    ></el-option>
                </el-select>

                <el-select
                    v-model="formPropHK.building_name"
                    :loading="loading"
                    filterable
                    allow-create
                    :placeholder="$t('addProperty.placeholder_BuildingA')"
                    @change="changeHKPropertyBuilding"
                    v-if="lan != 'en'"
                >
                    <el-option
                        v-for="item in buidlingList"
                        :key="item.id"
                        :label="item.name"
                        :value="item"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-row :gutter="8">
                <el-col :sm="12" :xs="24">
                    <el-form-item :label="$t('addProperty.floor')" prop="floor_name">
                        <el-select
                            v-model="formPropHK.floor_name"
                            filterable
                            allow-create
                            :placeholder="$t('addProperty.selectOne')"
                            @change="changeApartmentNum"
                            value-key="_index"
                        >
                            <el-option
                                v-for="(item, index) in unitList"
                                :key="index"
                                :label="item.floor"
                                :value="item"
                            >
                                <span>{{ item.floor }} {{ item.unit }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :sm="12" :xs="24">
                    <el-form-item :label="$t('addProperty.unitNo')" prop="apartmentNumber">
                        <el-select v-model="formPropHK.apartmentNumber" filterable allow-create>
                            <!-- <el-option
                                v-for="(item, index) in formPropHK.floor_name"
                                :key="index"
                                :label="item.unit"
                                :value="item.unit"
                            ></el-option>-->
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-form-item :label="$t('addProperty.address')" class="border-bottom" prop="address">
                <el-input
                    :placeholder="$t('addProperty.placeholder_address1')"
                    v-model="formPropHK.address"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item
                :label="$t('addProperty.purchasePrice')"
                class="p-relative"
                prop="purchasePrice"
            >
                <span class="prepend placeholderPend">{{collection.country.currency_symbol}}</span>
                <numeric-input type="number" v-model="formPropHK.purchasePrice"></numeric-input>
                <span class="append placeholderPend">{{collection.country.currency}}</span>
            </el-form-item>
            <el-form-item
                :label="$t('addProperty.ownership')"
                class="strongText"
                prop="ownershipType"
            >
                <el-row>
                    <el-radio-group v-model="formPropHK.ownershipType">
                        <el-col :span="24">
                            <el-radio
                                class="normal"
                                label="Freehold"
                            >{{$t('addProperty.ownership_Freehold')}}</el-radio>
                        </el-col>
                        <el-col :span="24">
                            <el-radio
                                class="normal"
                                label="Leasehold"
                            >{{$t('addProperty.ownership_Leasehold')}}</el-radio>
                        </el-col>
                    </el-radio-group>
                </el-row>
            </el-form-item>
            <el-form-item
                :label="$t('addProperty.totalLength')"
                prop="leaseholdDuration"
                v-if="formPropHK.ownershipType == 'Leasehold'"
            >
                <el-input-number
                    v-model="formPropHK.leaseholdDuration"
                    :min="1"
                    :max="100"
                    label="50 year(s)"
                ></el-input-number>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="goToStep">{{$t('addProperty.next')}}</el-button>
            </el-form-item>
        </el-form>

        <el-form
            :label-position="'top'"
            label-width="80px"
            ref="formPropCN"
            :rules="formRuleCN"
            :model="formPropCN"
            v-if="property_country_flag == 'CN'"
        >
            <el-row :gutter="8" class="type-card">
                <el-col :xs="24" :sm="12">
                    <el-form-item prop="city" :label="$t('addProperty.city')">
                        <el-input
                            :placeholder="$t('addProperty.placeholder_shanghai')"
                            v-model="formPropCN.city"
                            clearable
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12">
                    <el-form-item
                        prop="addressLine2"
                        :label="$t('addProperty.district')"
                        class="lh-normal"
                    >
                        <el-input
                            :placeholder="$t('addProperty.placeholder_Jingan')"
                            v-model="formPropCN.addressLine2"
                            clearable
                            @change="checkChinese('district')"
                        ></el-input>
                        <span class="enterTip">{{$t('addProperty.enterTip')}}</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item :label="$t('addProperty.propertyName')" prop="name" class="lh-normal">
                <el-input
                    :placeholder="$t('addProperty.placeholder_buildingName')"
                    v-model="formPropCN.name"
                    clearable
                    @change="checkChinese('name')"
                ></el-input>
                <span class="enterTip">{{$t('addProperty.enterTip')}}</span>
            </el-form-item>
            <el-form-item :label="$t('addProperty.address')" prop="address">
                <el-input
                    :placeholder="$t('addProperty.placeholder_road')"
                    v-model="formPropCN.address"
                    clearable
                ></el-input>
            </el-form-item>
            <el-row :gutter="8">
                <el-col :sm="12" :xs="24">
                    <el-form-item :label="$t('addProperty.unitNo')">
                        <el-input v-model="formPropCN.apartmentNumber" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :sm="12" :xs="24">
                    <el-form-item :label="$t('addProperty.postalCode')">
                        <el-input placeholder="200040" v-model="formPropCN.postalCode" clearable></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item
                :label="$t('addProperty.purchasePrice')"
                class="p-relative border-top"
                prop="purchasePrice"
            >
                <span class="prepend placeholderPend">{{collection.country.currency_symbol}}</span>
                <numeric-input type="number" v-model="formPropCN.purchasePrice"></numeric-input>
                <span class="append placeholderPend">{{collection.country.currency}}</span>
            </el-form-item>
            <el-form-item
                :label="$t('addProperty.ownership')"
                class="strongText"
                prop="ownershipType"
            >
                <el-row>
                    <el-radio-group v-model="formPropCN.ownershipType">
                        <el-col :span="24">
                            <el-radio
                                class="normal"
                                label="Freehold"
                            >{{$t('addProperty.ownership_Freehold')}}</el-radio>
                        </el-col>
                        <el-col :span="24">
                            <el-radio
                                class="normal"
                                label="Leasehold"
                            >{{$t('addProperty.ownership_Leasehold')}}</el-radio>
                        </el-col>
                    </el-radio-group>
                </el-row>
            </el-form-item>

            <el-form-item
                :label="$t('addProperty.totalLength')"
                prop="leaseholdDuration"
                v-if="formPropCN.ownershipType == 'Leasehold'"
            >
                <el-input-number
                    v-model="formPropCN.leaseholdDuration"
                    :min="1"
                    :max="100"
                    label="50 year(s)"
                ></el-input-number>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="goToStep">{{$t('addProperty.next')}}</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import { Message } from "element-ui";
import numericInput from "@/components/common/numeric-input.vue";
export default {
    name: "addProp2",
    props: ["collection", "property_country_flag", "requestParams"],
    data() {
        const $t = this.$t.bind(this);
        return {
            lan: "",
            formRuleHK: {
                name: {
                    required: true,
                    message: $t("addProperty.nameError"),
                    trigger: ["blur", "change"]
                },
                building_name: {
                    required: true,
                    message: $t("addProperty.buildingError"),
                    trigger: ["blur", "change"]
                },
                floor_name: {
                    required: true,
                    message: $t("addProperty.floorError"),
                    trigger: ["blur", "change"]
                },
                address: {
                    required: true,
                    message: $t("addProperty.addressError"),
                    trigger: ["blur", "change"]
                },
                apartmentNumber: {
                    required: true,
                    message: $t("addProperty.apartmentNumError"),
                    trigger: ["blur", "change"]
                },
                purchasePrice: {
                    required: true,
                    message: $t("addProperty.purchasePriceError"),
                    trigger: ["blur", "change"]
                },
                ownershipType: {
                    required: true,
                    message: $t("addProperty.ownershipError"),
                    trigger: ["blur", "change"]
                },
                leaseholdDuration: {
                    required: true,
                    message: $t("addProperty.yearsOfLeaseholeError"),
                    trigger: ["blur", "change"]
                }
            },
            formPropHK: {
                name: {},
                building_name: "",
                floor_name: {},
                apartmentNumber: "",
                purchasePrice: "100000",
                ownershipType: "Freehold",
                leaseholdDuration: "90"
            },
            formRuleCN: {
                city: {
                    required: true,
                    message: $t("addProperty.cityError"),
                    trigger: ["blur", "change"]
                },
                addressLine2: {
                    required: true,
                    message: $t("addProperty.districtError"),
                    trigger: ["blur", "change"]
                },
                name: {
                    required: true,
                    message: $t("addProperty.nameError"),
                    trigger: ["blur", "change"]
                },
                address: {
                    required: true,
                    message: $t("addProperty.nameError"),
                    trigger: ["blur", "change"]
                },
                purchasePrice: {
                    required: true,
                    message: $t("addProperty.purchasePriceError"),
                    trigger: ["blur", "change"]
                },
                ownershipType: {
                    required: true,
                    message: $t("addProperty.ownershipError"),
                    trigger: ["blur", "change"]
                }
            },
            formPropCN: {
                city: "",
                addressLine2: "",
                name: "",
                address: "",
                apartmentNumber: "",
                postalCode: "",
                purchasePrice: "100000",
                ownershipType: "Freehold",
                leaseholdDuration: "90"
            },
            formRule2: {
                city: {
                    required: true,
                    message: $t("addProperty.cityError"),
                    trigger: ["blur", "change"]
                },
                name: {
                    required: true,
                    message: $t("addProperty.nameError"),
                    trigger: ["blur", "change"]
                },
                address: {
                    required: true,
                    message: $t("addProperty.addressError"),
                    trigger: ["blur", "change"]
                },
                purchasePrice: {
                    required: true,
                    message: $t("addProperty.purchasePriceError"),
                    trigger: ["blur", "change"]
                },
                ownershipType: {
                    required: true,
                    message: $t("addProperty.ownershipError"),
                    trigger: ["blur", "change"]
                }
            },
            formProp2: {
                city: "",
                postalCode: "",
                address: "",
                addressLine2: "",
                name: "",
                apartmentNumber: "",
                purchasePrice: "100000",
                ownershipType: "Freehold",
                leaseholdDuration: "90"
            },

            locationList: [],
            buidlingList: [],
            unitList: [],
            property_unit_id: "",

            propertyNameUrl: "",
            buildingNameUrl: "",
            unitFloorUrl: "",

            loading: false,

            getHeader: {
                headers: {
                    Authorization: `Token ${this.requestParams.token}`
                }
            }
        };
    },

    beforeMount() {
        this.lan = this.$root.cookie.acreage;

        if (this.property_country_flag == "HK") {
            this.getPropertyInfo();
        }
    },

    methods: {
        getPropertyInfo() {
            this.propertyNameUrl = `${this.requestParams.ppbApi}api/homeprice_get_estates`;

            this.buildingNameUrl = `${this.requestParams.ppbApi}api/homeprice_get_buildings?estate=`;

            this.unitFloorUrl = `${this.requestParams.ppbApi}api/homeprice_get_valuations?building=`;

            this.loading = true;

            this.$http.get(this.propertyNameUrl, this.getHeader).then(resp => {
                this.locationList = resp.data.estates;
                this.loading = false;
            });
        },

        goToStep() {
            if (this.property_country_flag == "") {
                this.validatePropertyFields("formProp2");
            } else if (this.property_country_flag == "CN") {
                this.validatePropertyFields("formPropCN");
            } else if (this.property_country_flag == "HK") {
                this.validatePropertyFields("formPropHK");
            }
        },

        changeHKPropertyName() {
            this.formPropHK.building_name = "";
            this.loading = true;

            let id = this.formPropHK.name.id || "";
            if (id == "") {
                this.buidlingList = [];
            } else {
                this.$http
                    .get(`${this.buildingNameUrl}${id}`, this.getHeader)
                    .then(resp => {
                        this.loading = false;
                        this.buidlingList = resp.data.buildings;
                    });
            }
        },

        changeHKPropertyBuilding() {
            this.formPropHK.floor_name = "";
            let id = this.formPropHK.building_name.id || "";
            this.loading = true;

            if (id == "") {
                this.unitList = [];
            } else {
                this.$http
                    .get(`${this.unitFloorUrl}${id}`, this.getHeader)
                    .then(resp => {
                        this.loading = false;
                        let unitList = resp.data.units;
                        unitList.forEach(it => {
                            it._index = Math.random();
                        });
                        this.unitList = unitList;
                    });
            }
        },

        changeApartmentNum() {
            this.formPropHK.apartmentNumber = this.formPropHK.floor_name.unit;
        },

        validatePropertyFields(form) {
            this.$refs[form].validate(valid => {
                if (!valid) {
                    // this.triggerMessage("error", {
                    //     message: this.$t("addProperty.fieldsError")
                    // });
                } else {
                    let formObj = this[form];
                    if (formObj.ownershipType[0] == "Freehold") {
                        formObj.ownershipType = 1;
                    } else {
                        formObj.ownershipType = 2;
                    }
                    this.$emit("goToStep", {
                        step: 3,
                        form: formObj
                    });
                }
            });
        },

        triggerMessage(type, options) {
            options.duration = 6000;
            return Message[type](options);
        },

        checkChinese(tar) {
            let val;
            if (tar == "district") {
                this.formPropCN.addressLine2 = this.formPropCN.addressLine2.replace(
                    /[^\u4E00-\u9FA5]/g,
                    ""
                );
            } else if (tar == "name") {
                this.formPropCN.name = this.formPropCN.name.replace(
                    /[^0-9\u4E00-\u9FA5]/g,
                    ""
                );
            }
        }
    },

    components: {
        numericInput
    }
};
</script>
<style lang="scss" scoped>
.addProp-box {
    .border-top {
        border-top: 1px solid #ebebeb;
        padding-top: 30px;
        margin-top: 10px;
    }
    .border-bottom {
        border-bottom: solid 1px #ebebeb;
        padding-bottom: 30px;
    }

    .placeholderPend {
        position: absolute;
        top: 0;
        font-size: 14px;
        font-weight: 500;
        color: var(--brownish-grey);
    }
    .prepend {
        left: 16px;
        font-family: GothamBook;
    }
    .append {
        right: 16px;
        font-family: GothamMedium;
    }
    .strongText {
        font-family: GothamMedium;
        font-size: 16px;
        font-weight: 500;
        line-height: 1;
        color: #2e384d;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/account/addProp2.vue